import request from 'app/api/request';
import { setDocumentPermissions as setReduxDocumentPermissions, setSectionPermissions as setReduxSectionPermissions } from 'app/state/redux/documentSlice';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { permissionQueryKeys } from 'app/api/permission-queries/permission-queries';

export const usePermissions = (documentSuperId) => {
  const dispatch = useDispatch();
  const {
    data,
    isLoading,
    refetch: fetchPermissionData,
  } = useQuery(
    [permissionQueryKeys.documentPermissions, documentSuperId],
    async () => {
      const res = await request.get(`/gaby/documents/${documentSuperId}/current-user-permissions`);
      const { data } = res;
      dispatch(setReduxDocumentPermissions(data?.userDocumentPermissions));
      const sectionDictionary = {};
      data?.userSectionPermissions.forEach((permission) => (sectionDictionary[permission.sectionSuperId] = permission.permission));
      dispatch(setReduxSectionPermissions(sectionDictionary));
      return { userDocumentPermissions: data?.userDocumentPermissions, sectionPermissions: sectionDictionary ?? {} };
    },
    {
      enabled: !!documentSuperId,
      staleTime: 5 * 60 * 1000,
    }
  );

  return { documentPermissions: data?.userDocumentPermissions ?? [], sectionPermissions: data?.sectionPermissions ?? {}, fetchPermissionData, isLoading };
};
